/**
 * Predefined avatar images for student profiles (cartoon-style, no numbers).
 * Uses consistent avatar image URLs so the same image appears in profile picker, header, and leaderboard.
 */
const AVATAARS_BASE = "https://api.dicebear.com/7.x/avataaars/png";

const SEEDS = [
    "smile", "happy", "friendly", "student1", "student2", "learner",
    "star", "sunny", "bright", "cool", "ace", "hero",
];

export const PREDEFINED_AVATARS = SEEDS.map((seed, i) => ({
    key: `avatar_${i + 1}`,
    imageUrl: `${AVATAARS_BASE}?seed=${encodeURIComponent(seed)}&size=128`,
}));

/**
 * Get the image URL for a predefined avatar key (e.g. avatar_1).
 * Returns null if key is not a predefined avatar.
 */
export function getPredefinedAvatarImageUrl(avatarKey) {
    if (!avatarKey || typeof avatarKey !== "string" || !avatarKey.startsWith("avatar_")) {
        return null;
    }
    const num = parseInt(avatarKey.replace("avatar_", ""), 10);
    if (Number.isNaN(num) || num < 1 || num > PREDEFINED_AVATARS.length) {
        return null;
    }
    return PREDEFINED_AVATARS[num - 1].imageUrl;
}
